import { max } from "@amcharts/amcharts4/.internal/core/utils/Math";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {UppyHelper} from "../../utils/uppyHelper";
import JSZip = require("jszip/dist/jszip.min.js");


declare var ko: any;

export class modFileUploader_template extends vnTemplate {

    public uppyHelper: any;

    protected getTemplateHtml(): string {

        return `

            <div class="form-group">
                <label class="form-label">Files</label>
                <ul class="file-upload" data-bind="foreach: files, visible: isEnabled">
                    <li class="file-item">
                        <span data-bind="text: name"></span>
                        <div class="file-meta">
                            <div><strong>Title:</strong> <span data-bind="text: title"></span></div>
                            <div><strong>Description:</strong> <span data-bind="text: description"></span></div>
                            <div><strong>Version:</strong> <span data-bind="text: version"></span></div>
                            <div><strong>Status:</strong> <span data-bind="text: $data.moderationStatus ? $data.moderationStatus.name : 'Pending Review'"></span></div>
                            <div><strong>Deleted:</strong> <span data-bind="text: isDeleted ? 'Yes' : 'No'"></span></div>
                            <div><strong>Content:</strong> <button type="button" class="btn show-file-content" data-bind="event: { click: function(data, e){ $parent.onClickSeeContent(($index() + 1), e) } }" >see content</button><div class="content-modal" data-bind="attr: { 'id': 'file-item-' + ($index() + 1) }"><button type="button" class="btn close-button show-file-content" data-bind="event: { click: $parent.onClickSeeContent }" >X</button><span data-bind="html: content "></div></span></div>
                        </div>
                        <div class="w-btn">
                            <button class="btn-form icon i-delete" data-bind="visible: !isDeleted, click: $parent.onClickRemoveFile.bind($data, $index())"></button>
                            <button class="btn-form icon i-revert" data-bind="visible: isDeleted, click: $parent.onClickRestoreFile.bind($data, $index())"></button>
                            <button class="btn-form icon i-edit" data-bind="click: $parent.onClickEditFile.bind($data, $index())"></button>
                        </div>
                    </li>
                </ul>

                <button class="btn highlight" data-bind="event:{ click: onClickToggleUploader}, enable: isEnabled">Add File</button>
            </div>

            <div id="file-uploader-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Add File</h3>
                            <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body" style="padding-top: 0;" data-bind="css:{ 'is-hidden': !isOpen() }">

                            <div id="${this.idElement}-drag-drop" style="margin-bottom: 1rem"></div>

                            <div class="form-group">
                                <label for="file-title" class="form-label form-label-box">Title</label>
                                <input type="text" class="input-text" id="file-title" data-bind="value: title" required>
                            </div>

                            <div class="form-group">
                                <label for="file-description" class="form-label form-label-box">Description</label>
                                <input type="text" class="input-text" id="file-description" data-bind="value: description" required>
                            </div>

                            <div class="form-group" data-bind="visible: false">
                                <label for="file-content" class="form-label form-label-box">Content</label>
                                <input type="text" class="input-text" id="file-content" data-bind="value: content" required>
                            </div>

                            <div class="form-group">
                                <label for="file-version" class="form-label form-label-box">Version</label>
                                <input type="text" class="input-text" id="file-version" data-bind="value: version" required>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancel }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string {

        return "fileUploader_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            isEnabled: ko.observable(false),
            isOpen: ko.observable(false),
            files: ko.observableArray([]),
            fileObject: ko.observable(""),
            fileObjectIndex: ko.observable(-1),
            title: ko.observable(""),
            description: ko.observable(""),
            content: ko.observable(""),
            version: ko.observable(""),
            uppyConfigOptions: ko.observable({
                maxNumberOfFiles: 1,
                allowedFileTypes: ['application/zip', 'application/x-zip-compressed', 'application/x-7z-compressed', 'application/x-rar-compressed'],
                endpoint: 'https://ggmods.com/tusd',
            }),
            baseUrlForFiles: ko.observable("https://mods.ggmodsimages.com/"),
            onClickToggleUploader: function(data, event) {
                self.toggleUploader();
            },
            onClickCancel: function() {
                self.cancel();
            },
            onClickSave: function() {
                self.save();
            },
            onClickRemoveFile: function(index, data, event) {
                self.removeFile(index);
            },
            onClickRestoreFile: function(index, data, event) {
                self.restoreFile(index);
            },
            onClickEditFile: function(index, data, event) {
                self.editFileObject(data,index);
            },
            onClickSeeContent: function (data, event) { self.onClickSeeContent(data, event) }
        }
    }
    public setEnabled(enabled: boolean) {

        this.getTemplateViewModel().isEnabled(enabled);
    }

    public setIsOpen(isOpen: boolean) {

        this.getTemplateViewModel().isOpen(isOpen);
    }

    public setUppyConfigOptions(options) {

        this.getTemplateViewModel().uppyConfigOptions(options);
    }

    public initializeFileUploader() {

        const uppyConfigOptions = this.getTemplateViewModel().uppyConfigOptions();
        if (!uppyConfigOptions) {
            return;
        }

        this.uppyHelper = new UppyHelper(
            this.idElement + "-drag-drop",
            uppyConfigOptions,
            (file) => {return this.handleBeforeFileAdded(file);},
            (req) => {this.handleRequestHeaders(req);},
            (file) => {this.handleUploadComplete(file);},
            null,
            (fileTree) => {this.createContentTree(fileTree);},
        );
    }

    public setUppyFile(file) {

        this.uppyHelper.preloadUploadedFile(file);
    }

    public removeUppyFiles() {

        this.uppyHelper.clearFiles();
    }

    public setFiles(files){

        this.getTemplateViewModel().files(files);
    }

    public getFiles(){

        return this.getTemplateViewModel().files();
    }

    public handleBeforeFileAdded(file) {

        let modder = this.caller.getSelectedModder();

        if(!modder){
            this.uppyHelper.clearFile(file);
            alert("Please select a modder first.");
            return false;
        }
        return file;
    }

    public handleRequestHeaders(req) {

        let modder = this.caller.getSelectedModder();

        if (modder && modder.id) {
            req.setHeader('modderid', modder.id);
        }

        return req;
    }

    public handleUploadComplete(file){

        let modder = this.caller.getSelectedModder();
        if(!modder){
            return;
        }

        let url = this.getTemplateViewModel().baseUrlForFiles() + modder.id + "/" + file.name;
        file.url = url;
        this.getTemplateViewModel().fileObject(file);
    }

    public createContentTree(fileTree){
        const lines = fileTree.split(/\r?\n/);
        let arrayTree = [];
        let result = {};
        let maxLevels = 0;
        lines.forEach(line => {

                line = line.replace("[dir]","");
                line = line.replace("[file]","");
                let levels = line.split("/");
                const name = levels[levels.length - 1];
                if(maxLevels < levels.length){
                    maxLevels = levels.length;
                }
                if (name.startsWith('.') || line.startsWith('__MACOSX/')) {
                    console.log('Skipping hidden file', line);
                    return;
                }
                let current = result;

                levels.forEach((part, i) => {
                    if (!current[part]) {
                        current[part] = (i === levels.length - 1) ? part : {};
                    }
                    current = current[part];
                });

                arrayTree.sort((a, b) => a.id - b.id);
                arrayTree.concat(result);
                let test2 = current;

        })

        this.getTemplateViewModel().content(this.renderFileTree(result));
    }

    public renderFileTree(data) {
        const esc = (s) =>
            String(s)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");

        const isPlainObject = (v) =>
            v && typeof v === "object" && !Array.isArray(v);

        const isEmptyObject = (obj) => {
            if (!isPlainObject(obj)) return false;
            // ignore empty-string keys when deciding emptiness
            return Object.keys(obj).filter((k) => k !== "").length === 0;
        };

        function renderNode(obj) {
            let html = "<ul>";
            // Iterate keys, skipping empty-key placeholders
            for (const key of Object.keys(obj)) {
            if (key === "") continue; // ignore placeholder keys
            const val = obj[key];

            // Skip empty values
            if (val === "" || isEmptyObject(val)) continue;

            if (isPlainObject(val)) {
                // directory
                html += `<li class="dir"><span class="icon i-folder"></span>${esc(key)}${renderNode(val)}</li>`;
            } else {
                // file (string)
                html += `<li class="file"><span class="icon i-file"></span>${esc(key)}</li>`;
            }
            }
            html += "</ul>";
            return html;
        }

        // Root wrapper
        return `<ul class="filetree">${renderNode(data).replace(/^<ul>|<\/ul>$/g, "")}</ul>`;
    }

    protected save(){

        let file = this.getTemplateViewModel().fileObject();

        if(!file){
            return;
        }

        file.title = this.getTemplateViewModel().title();
        file.description = this.getTemplateViewModel().description();
        file.content = this.getTemplateViewModel().content();
        file.version = this.getTemplateViewModel().version();

        let files = this.getTemplateViewModel().files();
        let index = this.getTemplateViewModel().fileObjectIndex();
        if (index == -1) {
            files.push(file);
        }else{
            files[index] = file;
        }

        this.getTemplateViewModel().files([]);
        this.getTemplateViewModel().files(files);
        this.toggleUploader();
        this.resetFileObject();
    }

    protected cancel(){

        this.toggleUploader();
        this.resetFileObject();
    }

    protected removeFile(index){

        let files = this.getTemplateViewModel().files();

        //update file to isDeleted = 1
        if(index > -1){
            files[index].isDeleted = 1;
        }

        this.getTemplateViewModel().files([]);
        this.getTemplateViewModel().files(files)
    }

    protected restoreFile(index){

        let files = this.getTemplateViewModel().files();

        //update file to isDeleted = 0
        if(index > -1){
            files[index].isDeleted = 0;
        }

        this.getTemplateViewModel().files([]);
        this.getTemplateViewModel().files(files)
    }

    protected editFileObject(file, index){

        this.getTemplateViewModel().fileObject(file);
        this.getTemplateViewModel().fileObjectIndex(index);
        this.getTemplateViewModel().title(file.title);
        this.getTemplateViewModel().description(file.description);
        this.getTemplateViewModel().content(file.content);
        this.getTemplateViewModel().version(file.version);

        this.setUppyFile(file);
        this.uppyHelper.disableNewUpload();
        this.toggleUploader();
    }

    protected resetFileObject(){

        this.getTemplateViewModel().fileObject(null);
        this.getTemplateViewModel().fileObjectIndex(-1);
        this.getTemplateViewModel().title('');
        this.getTemplateViewModel().description('');
        this.getTemplateViewModel().content('');
        this.getTemplateViewModel().version('');

        this.removeUppyFiles();
        this.uppyHelper.enableNewUpload();
    }

    public toggleUploader(){

        document.getElementById('file-uploader-dialog').classList.toggle('is-visible');
        this.setIsOpen(!this.getTemplateViewModel().isOpen());
    }
    public onClickSeeContent(data, event){
        console.log('Uploader', event);
        this.caller.seeContent(data, event);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/modFileUploader_template.ts